/**
 * When the full workspace gets its compact chrome (src/ui/compact): decided by the window, never by the
 * user agent. Pure; the module keeps `html[data-chrome]` in step with it through `matchMedia`.
 */

export type ChromeMode = 'compact' | 'regular';

/** Below this width the toolbar cannot sit in one row with the drawers as columns (a tablet in portrait is 768–834). */
export const COMPACT_MAX_WIDTH_PX = 899;
/** Below this height a two-row toolbar plus the patient strip leaves too little for the image (a phone in landscape is ~412). */
export const COMPACT_MAX_HEIGHT_PX = 499;
export const COMPACT_MEDIA_QUERY = `(max-width: ${COMPACT_MAX_WIDTH_PX}px), (max-height: ${COMPACT_MAX_HEIGHT_PX}px)`;

/** A held finger that opens the viewport context menu (no right button on a touch screen). */
export const LONG_PRESS_MS = 500;
export const LONG_PRESS_MAX_TRAVEL_PX = 8;
/** Two taps that toggle a cell's full screen (the browser synthesises no dblclick on cornerstone's element). */
export const DOUBLE_TAP_MAX_GAP_MS = 300;
export const DOUBLE_TAP_MAX_DISTANCE_PX = 24;

export function chromeModeFor(width: number, height: number): ChromeMode {
  return width <= COMPACT_MAX_WIDTH_PX || height <= COMPACT_MAX_HEIGHT_PX ? 'compact' : 'regular';
}

export function isLongPress(heldMs: number, travelPx: number): boolean {
  return heldMs >= LONG_PRESS_MS && travelPx <= LONG_PRESS_MAX_TRAVEL_PX;
}

export function isDoubleTap({ gapMs, distancePx }: { gapMs: number; distancePx: number }): boolean {
  return gapMs <= DOUBLE_TAP_MAX_GAP_MS && distancePx <= DOUBLE_TAP_MAX_DISTANCE_PX;
}
